import { Link as ReactRouterLink } from "react-router-dom";
import MuiLink from "@mui/material/Link";

const RouterLink = (props) => (
  <MuiLink component={ReactRouterLink} {...props} />
);
export default RouterLink;
